import api from "../../../services/api.service"


export const keyboxModule = {
    namespaced: true,
    state: {
        data: {types: [], categories: []},
    },
    getters: {
        canReadRealEstate(state, getters, rootState, rootGetters) {
            return rootGetters['user/canRead']('real_estate');
        },
        canEditRealEstate(state, getters, rootState, rootGetters) {
            return rootGetters['user/canEdit']('real_estate');
        },
        getAllCategories(state) {
            if (state.data == null || state.data.categories == null)
                return [];
            return state.data.categories;
        },

        getAllTypes(state) {
            if (state.data == null || state.data.types == null)
                return [];
            return state.data.types;
        },

        allKeyboxStatus() {
            return [
                {value: "online", text: ('ONLINE')},
                {value: "offline", text: ('OFFLINE')},
                {value: "inProgress", text: ('IN PROGRESS')},
                {value: "error", text: ('ERROR')}
            ];
        },


    },
    mutations: {
        updateData(state, data) {
            let stateData = {};
            stateData.loaded = true;
            stateData.categories = data["Categories"];
            stateData.types = data["Types"];
            state.data = stateData;
        }
    },
    actions: {

        copySuccess(actions, id) {
            actions.dispatch('notifications/success',
                {title: 'Success', message: 'Keybox  ID ' + id + ' copied'},
                {root: true});

        },


        getAllKeyboxs(actions, {page, amount, filter, sortcolumn, sortby}) {

            return new Promise(function (resolve, reject) {

                api.sendRequest('keybox/get', {
                    buids: actions.rootGetters['data/getSelectedBranchesIds'].join(","),
                    page,
                    amount,
                    sortcolumn,
                    sortby
                }, filter).then(
                    (ans) => {
                        if (ans["Keyboxs"] == null)
                            return reject('Could not get Keyboxs');

                        resolve(ans);
                    }, (error) => {
                        reject(error.message)
                    })
            })

        },
  getAllKeyboxLogs(actions, {page, amount, filter, sortcolumn, sortby}) {

            return new Promise(function (resolve, reject) {

                api.sendRequest('keybox/getLogs', {
                    buids: actions.rootGetters['data/getSelectedBranchesIds'].join(","),
                    page,
                    amount,
                    sortcolumn,
                    sortby
                }, filter).then(
                    (ans) => {
                        if (ans["KeyboxLogs"] == null)
                            return reject('Could not get KeyboxLogs');

                        resolve(ans);
                    }, (error) => {
                        reject(error.message)
                    })
            })

        },

        deleteService(actions, {id}) {
            return new Promise((resolve, reject) => {

                api.sendRequest('keybox/delete/' + id, {}).then(
                    (ans) => {

                        if (ans["Deleted"] == null)
                            return reject('Could not delete service item ');

                        resolve(ans["Deleted"]);
                    }, (error) => {
                        reject(error.message)
                    })
            })
        },
        getKeyboxById(actions, {id}) {
            return new Promise((resolve, reject) => {

                api.sendRequest('keybox/id/' + id, {}).then(
                    (ans) => {

                        if (ans["Keybox"] == null)
                            return reject('Could not get keybox ');

                        resolve(ans["Keybox"]);
                    }, (error) => {
                        reject(error.message)
                    })
            })
        },
        updateDocumentFile(action, {id, file}) {
            return new Promise(function (resolve, reject) {
                api.sendRequest('keybox/update/file/' + id, null, file).then(
                    (ans) => {

                        action.dispatch('notifications/success',
                            {
                                title: {text: 'file %s', arguments: ['status']},
                                message: {text: '%s updated successfully', arguments: ['file']}
                            },
                            {root: true});
                        resolve(ans["editableFields"]);
                    }, (error) => {
                        reject(error.message)
                    })
            })
        },

        update(actions, {keybox}) {
            return new Promise((resolve, reject) => {

                api.sendRequest('keybox/update', null, keybox).then(
                    (ans) => {
                        actions.dispatch('notifications/success',
                            {title: 'Update keybox', message: 'Keybox updated successfully'},
                            {root: true});

                        if (ans["RowsUpdated"] == null)
                            return reject('Could not update keybox ');

                        resolve(ans["RowsUpdated"]);
                    }, (error) => {
                        reject(error.message)
                    })
            })
        },
        openSlot({ dispatch }, { keyboxId, slotNumber }) {
            return new Promise((resolve, reject) => {
                // Basic validation
                if (!keyboxId || slotNumber == null) {
                    reject("Invalid keybox or slot number");
                    return;
                }

                // Send API request
                api.sendRequest(`keybox/openSlot/${keyboxId}/${slotNumber}`, null, null)
                    .then((ans) => {
                        // Check backend response
                        if (!ans || !ans["Keybox"]) {
                            dispatch(
                                "notifications/error",
                                {
                                    title: "Keybox Slot",
                                    message: "Could not open slot (device offline or no response)",
                                },
                                { root: true }
                            );
                            return reject("Could not open slot (device offline or no response)");
                        }

                        // ✅ Success notification
                        dispatch(
                            "notifications/success",
                            {
                                title: { text: "%s opened", arguments: ["Slot"] },
                                message: {
                                    text: "Slot %s opened successfully",
                                    arguments: [slotNumber],
                                },
                            },
                            { root: true }
                        );

                        resolve(ans["Keybox"]);
                    })
                    .catch((error) => {
                        // ❌ Error notification
                        dispatch(
                            "notifications/error",
                            {
                                title: "Open Keybox Slot",
                                message:
                                    typeof error === "object" && error.message !== undefined
                                        ? error.message
                                        : error || "Unexpected error while opening slot",
                            },
                            { root: true }
                        );
                        reject(error.message || error);
                    });
            });
        },
        openAllSlots({ dispatch }, { keyboxId }) {
            return new Promise((resolve, reject) => {
                // Validate input
                if (!keyboxId) {
                    reject("Invalid keybox ID");
                    return;
                }

                // Send API request
                api.sendRequest(`keybox/openAllSlots/${keyboxId}`, null, null)
                    .then((ans) => {
                        // Validate backend result
                        if (!ans || !ans["Keybox"]) {
                            dispatch(
                                "notifications/error",
                                {
                                    title: "Keybox Slots",
                                    message: "Could not open all slots (device offline or no response)",
                                },
                                { root: true }
                            );
                            return reject("Could not open all slots (device offline or no response)");
                        }

                        // ✅ Success notification
                        dispatch(
                            "notifications/success",
                            {
                                title: { text: "%s opened", arguments: ["Keybox"] },
                                message: { text: "All slots were opened successfully" },
                            },
                            { root: true }
                        );

                        resolve(ans["Keybox"]);
                    })
                    .catch((error) => {
                        // ❌ Error notification
                        dispatch(
                            "notifications/error",
                            {
                                title: "Open All Slots",
                                message:
                                    typeof error === "object" && error.message !== undefined
                                        ? error.message
                                        : error || "Unexpected error while opening all slots",
                            },
                            { root: true }
                        );

                        reject(error.message || error);
                    });
            });
        },
        checkStatusLocker(actions, {keyboxId}) {
            return new Promise((resolve, reject) => {

                api.sendRequest('keybox/checkStatusLocker/' + keyboxId, null, null).then(
                    (ans) => {
                        actions.dispatch('notifications/success',
                            {title: 'Keybox Slots', message: 'Status fetched successfully'},
                            {root: true});

                        if (ans["Keybox"] == null)
                            return reject('Could not check status');

                        resolve(ans["Keybox"]);
                    }, (error) => {
                        reject(error.message)
                    })
            })
        },
        checkStatusLockerContract(actions, {contractId}) {
            return new Promise((resolve, reject) => {

                api.sendRequest('keybox/checkStatusLocker/contract/' + contractId, null, null).then(
                    (ans) => {
                        actions.dispatch('notifications/success',
                            {title: 'Keybox Slots', message: 'Status fetched successfully'},
                            {root: true});

                        if (ans["Keybox"] == null)
                            return reject('Could not check status');

                        resolve(ans["Keybox"]);
                    }, (error) => {
                        reject(error.message)
                    })
            })
        },openSlotFromContract({ dispatch }, { contractId }) {
            return new Promise((resolve, reject) => {
                // Validate input
                if (!contractId) {
                    reject("Invalid contract ID");
                    return;
                }

                // Send API request
                api.sendRequest(`keybox/openSlotContract/${contractId}`, null, null)
                    .then((ans) => {
                        // Validate backend response
                        if (!ans || !ans["Keybox"]) {
                            dispatch(
                                "notifications/error",
                                {
                                    title: "Keybox Slot",
                                    message: "Could not open slot (device offline or no response)",
                                },
                                { root: true }
                            );
                            return reject("Could not open slot (device offline or no response)");
                        }

                        // ✅ Success notification
                        dispatch(
                            "notifications/success",
                            {
                                title: { text: "%s opened", arguments: ["Slot"] },
                                message: { text: "Slot for this contract was opened successfully" },
                            },
                            { root: true }
                        );

                        resolve(ans["Keybox"]);
                    })
                    .catch((error) => {
                        // ❌ Error notification
                        dispatch(
                            "notifications/error",
                            {
                                title: "Open Slot from Contract",
                                message:
                                    typeof error === "object" && error.message !== undefined
                                        ? error.message
                                        : error || "Unexpected error while opening contract slot",
                            },
                            { root: true }
                        );

                        reject(error.message || error);
                    });
            });
        },
        toggleLockerAccess(actions, {contractId,action}) {
            return new Promise((resolve, reject) => {

                api.sendRequest('keybox/toggleLockerAccess/' + contractId+ '/'+action, null, null).then(
                    (ans) => {
                        actions.dispatch('notifications/success',
                            {title: 'Contract', message: 'Access updated successfully'},
                            {root: true});

                        if (ans["Contract"] == null)
                            return reject('Could not update access');

                        resolve(ans["Contract"]);
                    }, (error) => {
                        reject(error.message)
                    })
            })
        },
        addKeybox(actions, {keybox}) {
            return new Promise((resolve, reject) => {
                api.sendRequest('keybox/create', null, keybox).then(
                    (ans) => {
                        actions.dispatch('notifications/success',
                            {title: 'Add keybox', message: 'Keybox created successfully'},
                            {root: true});

                        if (ans["Keybox"] == null)
                            return reject('Could not create keybox ');

                        console.log("keybox answer created: ", ans)
                        resolve(ans["Keybox"]);
                    }, (error) => {
                        reject(error.message)
                    })
            })
        }
    },
};
